import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TTDCampaign } from '@feathr/blackbox/src/campaigns';
import { FormSummaryItem } from '@feathr/components';
import { useObjectiveUtils } from '@feathr/extender/hooks';
import { useFlags } from '@feathr/report_components';

import type { ISummaryProps } from './CampaignSummary.types';

const OptimizationSummary = observer(({ campaign }: ISummaryProps): JSX.Element => {
  const TTDCampaign = campaign as TTDCampaign;
  const { t } = useTranslation();
  const { hasBuildReachAwarenessPP } = useFlags();
  const { createSelectOptions } = useObjectiveUtils();
  const options = createSelectOptions(
    TTDCampaign.getAvailableObjectives({ hasBuildReachAwarenessPP }),
  );

  const objectiveId = campaign.get('objective');
  const objectiveOption = options.find((option) => option.id === objectiveId);
  const objectiveName = objectiveOption?.name || objectiveId;

  const optimizationSummary = `${campaign.get('bidding_strategy')._cls} | ${objectiveName}`;

  return (
    <FormSummaryItem
      label={t('Optimization')}
      name={'summary_optimization'}
      value={optimizationSummary}
    />
  );
});

OptimizationSummary.displayName = 'OptimizationSummary';

export default OptimizationSummary;
